import { type ComponentProps, useCallback, useMemo } from 'react';

import { useFocus } from '@atlassian/global-shortcuts/focus';
import { useProjects } from '@atlassian/global-shortcuts/projects';
import { useTeams } from '@atlassian/global-shortcuts/teams';
import { GlobalSideNavigation } from '@atlassian/global-side-navigation/GlobalSideNavigation';

import { getConfig } from '@townsquare/config';
import { SideNavAppItem as SideNavAppItemID } from '@townsquare/navigation-config/nav4';
import { useOrgContextOrgId } from '@townsquare/org-context';
export const useSideNavAppItemsForNavPlatform = (): ComponentProps<
	typeof GlobalSideNavigation
>['shortcuts'] => {
	const config = getConfig();
	const orgId = useOrgContextOrgId();
	const focusItem = useFocus('', { menuItemId: SideNavAppItemID.FOCUS });

	const teamsItem = useTeams(
		useCallback(
			() => (!orgId ? `${config.fullUrl}/people` : `${config.fullUrl}/o/${orgId}/people`),
			[config.fullUrl, orgId],
		),
		{ menuItemId: SideNavAppItemID.TEAMS_APP },
	);

	const projectsItem = useProjects(
		useCallback(
			() => (!orgId ? `${config.fullUrl}/projects` : `${config.fullUrl}/o/${orgId}/projects`),
			[config.fullUrl, orgId],
		),
		{ menuItemId: SideNavAppItemID.PROJECTS },
	);

	return useMemo(
		() => ({
			[SideNavAppItemID.FOCUS]: focusItem,
			[SideNavAppItemID.TEAMS_APP]: teamsItem,
			[SideNavAppItemID.PROJECTS_APP]: projectsItem,
		}),
		[focusItem, teamsItem, projectsItem],
	);
};
